import { render, staticRenderFns } from "./index_mobile.vue?vue&type=template&id=71cab72a&scoped=true"
import script from "./index_mobile.vue?vue&type=script&lang=js"
export * from "./index_mobile.vue?vue&type=script&lang=js"
import style0 from "./index_mobile.vue?vue&type=style&index=0&id=71cab72a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cab72a",
  null
  
)

export default component.exports